import React from 'react';
import { Input, Button } from '@/components/atoms/Header';
import styles from './Search.module.scss';

const View: React.FC<{
  placeholder: string;
  value: string;
  setValue: (s: string) => void;
  search: () => void;
  loading: boolean;
  validInput: boolean;
}> = ({ placeholder, value, setValue, search, loading, validInput }) => {
  return (
    <div className={styles.container}>
      <div className={styles.input}>
        <Input
          placeholder={placeholder}
          value={value}
          onChange={setValue}
          onSubmit={search}
          loading={loading}
          invalid={!validInput}
        />
      </div>
      <Button
        loading={loading}
        invalid={!validInput}
        onClick={search}
      />
    </div>
  );
};

export default View;
